'use client';
import { Cart } from '@peerless/data-access/cart-service';
import { createContext } from 'react';

type RedirectableActionResponse = { redirect?: string; cartData?: Cart };
export const CartSidebarUIStateContext = createContext({
  isAuthenticated: false,
  isCheckoutPath: false,
  isOpen: false,
  isLoadingCartData: false,
  setIsLoadingCartData: (open: boolean) => {
    // no-op
    console.warn('setIsLoadingCartData not implemented');
  },
  toggleIsOpen: () => {
    // no-op
    console.warn('toggleIsOpen not implemented');
  },
  setIsOpen: (open: boolean) => {
    // no-op
    console.warn('setIsOpen not implemented');
  },
  cartData: undefined as Cart | undefined,
  setCartData: (data: Cart | undefined) => {
    // no-op
    console.warn('setCartData not implemented');
  },
  refetchData: async (): Promise<RedirectableActionResponse | undefined> => {
    // no-op
    console.warn('refetchData not implemented');
    return undefined;
  },
  addProductToCart: async (skus: string | string[]) => {
    // no-op
    console.warn('addProductToCart not implemented');
  },
  updateProductInCart: async (sku: string, quantity: number) => {
    // no-op
    console.warn('addProductToCart not implemented');
  },
});
